<img hisImage="link" alt="{{'psv.Ekontakt.webseite'|hisUi}}" title="{{'psv.Ekontakt.webseite'|hisUi}}" class="inlineicon">
<a href="{{url}}">{{value}}</a>
